import { getEnabledSwitchActions } from '@/utils/common/tableActions'
import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('system.notify.topic.receiver.management'),
        action: (obj) => {
          this.sidePageTriggerHandle(this, 'NotifyTopicSidePage', {
            id: obj.id,
            resource: 'topics',
            apiVersion: 'v1',
            getParams: this.getParam,
          }, {
            list: this.list,
            tab: 'subscriber',
          })
        },
      },
      {
        label: i18n.t('system.text_153'),
        actions: (obj) => {
          return [
            {
              label: i18n.t('iam.modify_sms_template'),
              permission: 'topics_update',
              action: (row) => {
                this.createDialog('NotifyTopicUpdateSmsDialog', {
                  onManager: this.onManager,
                  data: [row],
                  columns: this.columns,
                })
              },
              meta: () => {
                return {
                  validate: this.isAdminMode,
                }
              },
            },
            ...getEnabledSwitchActions(this, obj, ['topics_perform_enable', 'topics_perform_disable'], {
              resourceName: this.$t('dictionary.notify-topic'),
              metas: [
                () => {
                  return {
                    validate: this.isAdminMode && !obj.enabled,
                  }
                },
                () => {
                  return {
                    validate: this.isAdminMode && obj.enabled,
                  }
                },
              ],
            }),
          ]
        },
      },
    ]
  },
}
